function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
export var processPropertiesForState = function(breakpoints) {
    var windowObject = typeof window !== 'undefined' ? window : undefined;
    return _objectSpread({}, breakpoints, windowOrientationProperties(windowObject), screenProperties(windowObject), sizeProperties(breakpoints, windowObject), checkSsrEnv(breakpoints));
};
var screenProperties = function(target) {
    var ref, ref1, ref2;
    var orientationType = target === null || target === void 0 ? void 0 : (ref = target.screen) === null || ref === void 0 ? void 0 : (ref1 = ref.orientation) === null || ref1 === void 0 ? void 0 : ref1.type;
    var widthScreen = target === null || target === void 0 ? void 0 : (ref2 = target.screen) === null || ref2 === void 0 ? void 0 : ref2.width;
    var heightScreen = target === null || target === void 0 ? void 0 : target.screen.height;
    var landscapeScreen = orientationType === 'landscape-primary' || orientationType === 'landscape-secondary';
    var portraitScreen = orientationType === 'portrait-primary' || orientationType === 'portrait-secondary';
    if (landscapeScreen || portraitScreen) {
        return _objectSpread({
            landscapeScreen: landscapeScreen,
            portraitScreen: portraitScreen
        }, widthScreen && {
            widthScreen: widthScreen
        }, heightScreen && {
            heightScreen: heightScreen
        });
    }
    return _objectSpread({}, widthScreen && {
        widthScreen: widthScreen
    }, heightScreen && {
        heightScreen: heightScreen
    });
};
var windowOrientationProperties = function(target) {
    if (target && target.matchMedia) {
        var portraitWindow = target.matchMedia('all and (orientation: portrait)').matches;
        var landscapeWindow = target.matchMedia('all and (orientation: landscape)').matches;
        if (portraitWindow || landscapeWindow) {
            return {
                portraitWindow: portraitWindow,
                landscapeWindow: landscapeWindow
            };
        }
    }
    return {};
};
var sizeProperties = function(breakpoints, windowObject) {
    if (windowObject === null || windowObject === void 0 ? void 0 : windowObject.matchMedia) {
        var s = breakpoints.s, m = breakpoints.m, l = breakpoints.l, xl = breakpoints.xl, xxl = breakpoints.xxl;
        var innerHeight = windowObject.innerHeight, innerWidth = windowObject.innerWidth;
        var match = function(cssString) {
            return windowObject.matchMedia("all and ".concat(cssString)).matches;
        };
        var isXXL = typeof xxl === 'number' && match("(min-width: ".concat(xxl, "px)"));
        var isXL = !isXXL && (typeof xxl === 'number' ? match("(min-width: ".concat(xl, "px) and (max-width: ").concat(xxl, "px)")) : match("(min-width: ".concat(xl, "px)")));
        var isL = !isXL && match("(min-width: ".concat(l, "px) and (max-width: ").concat(xl, "px)"));
        var isM = !isL && match("(min-width: ".concat(m, "px) and (max-width: ").concat(l, "px)"));
        var isS = !isM && match("(min-width: ".concat(s, "px) and (max-width: ").concat(m, "px)"));
        var isDefaultSize = !innerWidth || match("(max-width: ".concat(Number(s) - 1, "px)"));
        return _objectSpread({}, innerHeight ? {
            heightWindow: innerHeight
        } : {}, innerWidth ? {
            widthWindow: innerWidth
        } : {}, {
            isDefaultSize: isDefaultSize,
            isS: isS,
            isM: isM,
            isL: isL,
            isXL: isXL,
            isXXL: isXXL
        });
    }
    return {};
};
var checkSsrEnv = function(param) {
    var ssrSize = param.ssrSize;
    var isSsr = typeof window === 'undefined';
    if (isSsr) {
        switch(ssrSize){
            case 'defaultSize':
                return {
                    isDefaultSize: true,
                    isSsr: isSsr
                };
            case 's':
                return {
                    isS: true,
                    isSsr: isSsr
                };
            case 'm':
                return {
                    isM: true,
                    isSsr: isSsr
                };
            case 'l':
                return {
                    isL: true,
                    isSsr: isSsr
                };
            case 'xl':
                return {
                    isXL: true,
                    isSsr: isSsr
                };
            case 'xxl':
                return {
                    isXXL: true,
                    isSsr: isSsr
                };
            default:
                break;
        }
    }
    return {};
};
